module.exports = __webpack_public_path__ + "media/customizations/roselyn/back-41b89d30fd5ccced5d1d4b04e9b8cd60.jpg";